import Slider from './slider';

interface LoginCardProps {
  content: React.ReactNode;
  title?: string;
  description?: string | React.ReactNode;
}

const LoginCard: React.FC<LoginCardProps> = ({ content, title, description }) => {
  return (
    <div className='flex flex-col xl:flex-row items-center justify-between w-full xl:max-w-[95%] h-[calc(100vh-150px)] gap-10'>
      <div className='flex flex-grow justify-center pt-16 md:pt-0'>
        <div className='flex flex-col gap-10 w-[90%] max-w-[400px]'>
          <div>
            <h1 className='font-bold text-3xl'>{title}</h1>
            <p className='text-[#6F7789] font-montserrat text-base font-normal leading-[1.4] mt-1'>
              {description}
            </p>
          </div>
          <div className='pb-5'>{content}</div>
        </div>
      </div>
      <div className='min-h-[600px] xl:h-full w-[95%] xl:w-1/2 max-w-[600px] pt-5'>
        <Slider />
      </div>
    </div>
  );
};

export default LoginCard;
